import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { last } from 'lib/array/arrayUtils'
import moment from 'moment'
import { rem } from 'polished'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import { useIntl } from 'react-intl'

const AirlineLogoImage = styled(Image)`
  height: ${rem(20)};
  width: auto;
`

interface Props {
  flight: App.JourneyV2
  showSegments?: boolean
}

function FareFamilySelectModalSingleRouteFareHeaderItem({
  flight,
  showSegments = true,
}: Props) {
  const intl = useIntl()
  const firstFlight = flight.flightGroup.flights[0]
  const lastFlight = last(flight.flightGroup.flights)
  const departureDate = moment(firstFlight.departureDateTime).format(DMY_CASUAL_FORMAT)
  const departureDateTime = `${departureDate} ${firstFlight.departingTime}`

  const carrierWithDateLabel = intl.formatMessage(
    {
      id: '36riGxde_XTiRHnO5H-p',
      defaultMessage: '{carrierName} · {dateTime}',
      description: 'Carrier name with departure date and time in fare family header',
    },
    { carrierName: flight.carrierName, dateTime: departureDateTime },
  )

  const departureLabel = intl.formatMessage(
    {
      id: 'ny_Qsp21eiwtdwGbaYyj',
      defaultMessage: '{airportName} ({airportCode})',
      description: 'Departure airport name with code in fare family header',
    },
    { airportName: firstFlight.departureAirportName, airportCode: firstFlight.departureAirport },
  )
  const arrivalLabel = intl.formatMessage(
    {
      id: 'oN9p_kPLXoIchznMH75-',
      defaultMessage: '{airportName} ({airportCode})',
      description: 'Arrival airport name with code in fare family header',
    },
    { airportName: lastFlight.arrivalAirportName, airportCode: lastFlight.arrivalAirport },
  )

  return <Group data-testid="fare-family-header-item" direction="vertical" desktopDirection="horizontal" verticalAlign="center" gap="4 0" desktopGap="0 8">
    {showSegments && <Group direction="horizontal" verticalAlign="center">
      <BodyText variant="medium" colour="light-foreground-alt" weight="bold">{departureLabel}</BodyText>
      <LineArrowRightIcon size="XS" />
      <BodyText variant="medium" colour="light-foreground-alt" weight="bold">{arrivalLabel}</BodyText>
    </Group>}

    <Group direction="horizontal" verticalAlign="center" gap="0 8">
      {flight.carrierBrandMark && (
        <AirlineLogoImage
          image={{ url: flight.carrierBrandMark }}
        />
      )}

      <BodyText variant="medium" colour="light-foreground-alt">{carrierWithDateLabel}</BodyText>
    </Group>
  </Group>
}

export default FareFamilySelectModalSingleRouteFareHeaderItem
